import React from "react";
import ServicePage from "../components/ServicePage";
function ManagedITSupportPage() {
	const title = "SMS Terms & Conditions and Privacy Statement";

	const content = {
		title: "SMS Terms & Conditions and Privacy Statement ",
		paragraphs: [],
		mainOffer: {
			title: "SMS Terms & Conditions",
			description:
				"",
			bulletPoints: [
				`RightClick Professional Services SMS Terms & Conditions`,
				`Effective Date: 10/3/2025`,

				`1. Overview`,
				`RightClick Professional Services ("RPS," "we," "us," or "our") may send SMS (text) messages to clients and contacts who have engaged with our support team. By communicating with us via text message, you agree to these Terms & Conditions.`,

				`2. Types of Messages You May Receive`,
				`RPS uses SMS solely for client service and support purposes. Messages may include:`,
				`- Replies to support tickets or service requests`,
				`- Clarifications or updates related to an open ticket`,
				`- Scheduling or coordination related to technical support`,
				`RPS does not use SMS for marketing, promotional, or informational campaigns.`,

				`3. Message Frequency`,
				`RPS only sends SMS messages in direct response to your inquiries or active support tickets. We do not proactively initiate text conversations or send automated notifications. Message frequency varies and depends entirely on your ticket activity; RPS does not send recurring marketing or promotional messages.`,

				`4. Message and Data Rates`,
				`Message and data rates may apply according to your mobile carrier's plan. RPS is not responsible for any fees charged by your carrier.`,

				`5. Privacy`,
				`Your privacy is important to us. Please review our Privacy Policy (https://www.rightclickproserve.com/privacy) for details on how we collect, use, and protect your information.`,

				`6. Opt-In`,
				`By texting RPS or providing your number during a support interaction, you consent to receive SMS responses related to that specific inquiry or ticket. Consent is not required to purchase or receive services.`,

				`7. Opt-Out`,
				`You may opt out at any time by replying STOP to any RPS text message. After opting out, you will receive one final confirmation message. You may also contact us at support@rightclickproserve.com to be removed.`,

				`8. Help`,
				`For assistance, reply HELP to any RPS message or email support@rightclickproserve.com.`,

				`9. Supported Carriers`,
				`SMS delivery is supported by major U.S. carriers including AT&T, Verizon, T-Mobile, and others. Delivery may not be available on all networks.`,

				`10. Changes to These Terms`,
				`We may update these Terms & Conditions from time to time. The latest version will always be available at this URL.`,

				`-----------------------------------------------------------------`,

				`RightClick Professional Services SMS Privacy Policy`,
				`Effective Date: 10/3/2025`,



				`1. Overview`,
				`RightClick Professional Services ("RPS," "we," "us," or "our") respects your privacy and is committed to protecting the personal information you share with us through SMS communications. This Privacy Policy explains how we collect, use, and safeguard information related to text message interactions.`,

				`2. Information We Collect`,
				`When you communicate with RPS by SMS, we may collect the following types of information:`,
				`- Your mobile phone number`,
				`- Message content exchanged between you and RPS`,
				`- Date, time, and delivery status of messages`,
				`- Related service ticket or client account information (if applicable)`,

				`3. How We Use Your Information`,
				`RPS uses SMS data only to provide customer service and support, including:`,
				`- Responding to your service tickets or technical support inquiries`,
				`- Coordinating appointments or troubleshooting steps`,
				`- Maintaining internal records related to support interactions`,
				`We do not use SMS data for marketing, promotional, or advertising purposes.`,

				`4. Data Retention`,
				`RPS retains SMS correspondence only as long as necessary to fulfill the purpose of the interaction or to meet applicable legal and business requirements. Messages may be logged within our support systems (such as Autotask or Datto RMM) for service documentation and audit purposes.`,

				`5. Information Sharing`,
				`RPS does not share, sell, rent, or disclose mobile opt-in data or consent to any third parties for marketing or any other purpose.`,

				`6. Security`,
				`We implement appropriate technical and organizational measures to protect SMS data from unauthorized access, alteration, disclosure, or destruction. These measures include encryption, access controls, and secure system logging.`,

				`7. Your Rights`,
				`You may request access to, correction of, or deletion of your SMS-related data by contacting us at support@rightclickproserve.com. You may also opt out of SMS communications at any time by replying STOP to any RPS text message.`,

				`8. Children's Privacy`,
				`RPS does not knowingly communicate via SMS with individuals under the age of 18. If we learn that we have inadvertently exchanged messages with a minor, we will delete that data promptly.`,

				`9. Changes to This Policy`,
				`RPS may update this Privacy Policy periodically. The most current version will always be available at this URL. Continued use of SMS communications after any update constitutes acceptance of the revised policy.`,

				`10. Contact Us`,
				`If you have questions about this Privacy Policy or our SMS practices, please contact us at:`,
				`RightClick Professional Services`,
				`Email: support@therightclick.com`,
				`Website: https://www.rightclickproserve.com`,


			],
			illustration: "/images/illustrations/consulting-illustration.png",
		},
	};

	const services = null;

	return <ServicePage title={title} content={content} services={services} />;
}

export default ManagedITSupportPage;
